import React from "react";
import { MapPin, Phone, Mail, Trees } from "lucide-react";
import { CONTACT } from "../data/cabins";

export const Footer = () => {
  return (
    <footer
      id="contato"
      data-testid="site-footer"
      className="bg-[#1a3622] text-[#f7f5f0]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-20 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Trees className="h-6 w-6" />
            <span className="text-xl font-bold">Cabanas Igaratá</span>
          </div>
          <p className="text-sm text-[#f7f5f0]/80 leading-relaxed">
            Refúgios à beira da represa do Jaguari, cercados pela natureza de
            Igaratá - SP.
          </p>
          <p className="text-xs text-[#f7f5f0]/55 mt-4">CNPJ: {CONTACT.cnpj}</p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[#b55a30] font-bold mb-4">
            Contato
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0" />
              <a
                href={`https://wa.me/${CONTACT.phoneRaw}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="hover:underline"
              >
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0" />
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="hover:underline break-all"
              >
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[#b55a30] font-bold mb-4">
            Horários
          </h4>
          <ul className="space-y-2 text-sm text-[#f7f5f0]/85">
            <li>Check-in: a partir das 12:00</li>
            <li>Check-out: até as 16:00</li>
          </ul>

          <a
            href={`https://wa.me/${CONTACT.phoneRaw}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-cta-whatsapp"
            className="mt-6 inline-flex items-center justify-center rounded-full bg-[#b55a30] text-white px-6 py-3 text-sm font-semibold hover:bg-[#9d4d27] transition-colors"
          >
            Falar no WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 text-center text-xs text-[#f7f5f0]/55">
        © {new Date().getFullYear()} Cabanas Igaratá — Todos os direitos
        reservados.
      </div>
    </footer>
  );
};
